import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';

export interface DocumentDTO {
    id: string;
    chapterId: string;
    filename: string;
    storedFilename: string;
    size: number;
    contentType: string;
    uploadedBy: string;
    uploadedAtEpoch: number;
    uploadedDate: string;
    url: string;
}

export interface DocumentPageDTO {
    documents: DocumentDTO[];
    nextCursor: string | null;
    hasMore: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentApiService {
    private apiUrl = `${API_URL}documents`;

    constructor(private http: HttpClient) {
    }

    upload(file: File, chapterId: string): Observable<DocumentDTO> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('chapterId', chapterId);
        return this.http.post<DocumentDTO>(`${this.apiUrl}/upload`, formData);
    }

    list(chapterId: string, search?: string, cursor?: string, limit = 20): Observable<DocumentPageDTO> {
        let params = new HttpParams().set('chapterId', chapterId).set('limit', limit);
        if (search) {
            params = params.set('search', search);
        }
        if (cursor) {
            params = params.set('cursor', cursor);
        }
        return this.http.get<DocumentPageDTO>(this.apiUrl, {params});
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${encodeURIComponent(id)}`);
    }
}
